import React from 'react';

import ErrorInput from '../ErrorInput';
import ContextWrapper from '../ContextWrapper';

import { Label, Required, TextInput, TextContain, InputContain } from './Styled';

export const TextField = ({
  name,
  bold,
  label,
  value,
  type,
  onBlur,
  onFocus,
  context,
  disabled,
  onChange,
  className,
  onKeyPress,
  errorText,
  required,
  getContext,
  placeholder,
  backgroundColor,
  disableAutoComplete,
  removeRightBorderRadius
}) => {
  const inputError = context ? getContext().getError(name) : errorText;

  const onChangeHandler = (e) => {
    if (disabled) return;

    context
      ? getContext().onChange(name, e.target.value)
      : onChange(name, e.target.value);
  };

  const handleBlur = () => !disabled && onBlur(name, value);

  const handleKeyPress = (e) => onKeyPress(e);

  return (
    <TextContain className={className}>
      {label && <Label error={!!inputError}>{label}{required && <Required>*</Required>}</Label>}

      <InputContain error={!!inputError} backgroundColor={backgroundColor}>
        <TextInput
          id={name}
          bold={bold}
          type={type}
          value={value}
          onFocus={onFocus}
          error={!!inputError}
          disabled={disabled}
          onBlur={handleBlur}
          placeholder={placeholder}
          onChange={onChangeHandler}
          onKeyPress={handleKeyPress}
          removeRightBorderRadius={removeRightBorderRadius}
          autoComplete={disableAutoComplete ? 'new-password' : ''}
        />
      </InputContain>
      <ErrorInput errorText={inputError} />
    </TextContain>
  );
};

TextField.defaultProps = {
  onBlur: () => null,
  onFocus: () => null,
  onChange: () => null,
  onKeyPress: () => null,
  getContext: () => null,
  value: '',
  type: 'text',
  placeholder: 'Enter Text'
};

export default ContextWrapper(TextField);
